/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */

/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */

/* ====== Component Js/Jsx ====== */
import { StyleCommon } from '01Pages/Common/Style/StyleCommon';
import { ButtonIconCopyRegister, IconButtonDelete, IconButtonEdit, IconDelete, ButtonIconRegisterAuthEdit } from '02CommonUiParts/ButtonParts/ButtonBase';
import { assets } from '03CommonApiParts/Configuration';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  


/* ====== Styled Components ====== */
const SdivTitleButtonStyle = styled.div`//詳細ページタイトル
    display:flex;
	/* justify-content: space-between; */
    align-items:center;
    gap:20px;


`;
const SdivWrapperStyle = styled.div`//詳細ページ外枠
    padding-bottom:20px;
    min-width: fit-content;
    width: 100%;
`;

const SsvgIconStyle = styled.svg` //SVG用
    border-radius: 50%;
    padding:3px;
    overflow: visible;
    background-color: white;
    color: ${assets().color.blue};
    cursor: pointer;
    &:hover{
        background-color:${assets().color.blueHover};
    }
`;
/* ------ 適用日 ------*/
const SdivApplyStyle = styled.div`//適用日枠
    color: ${props =>props.status === props.active ? '#2E94B9': '#BDBDBD'};
    border: ${props =>props.status === props.active ? '1px solid #2E94B9': '1px solid #BDBDBD'};
	background-color: white;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
	transition: all ease-in-out .2s;
    &:hover{
        color: ${props =>props.status === props.active ? 'white': ''};
        background-color:${props =>props.status === props.active ? '#2E94B9': '#white'};
	};
`;
/* ------ ボタンのベース ------*/
const SButtonBaseOutlineStyle = styled.button`//ベース枠
    justify-content: center;
    background-color: ${assets().color.white};
    border: ${props => props.border ? props.border :'1px solid #2e94b9'};
    border-radius: 3px;
    color: ${assets().color.blue};
    display: flex;
    font-weight:bold;
    position: relative;
    padding:0px;
    align-items: center;
    pointer-events: ${(props) => props.pointerEvents};
    opacity: ${(props) => props.pointerEvents === 'none' ? 0.3 : 1};
    white-space:nowrap;
    &:hover{
        background-color: ${assets().color.whiteHover};
        cursor: pointer;
    }
    &:hover label{
        display: block;
    }
    &:active{
        top:1px;
        left:1px;
        box-shadow: none;
        background-color:${assets().color.blue};
        color:${assets().color.white};
    }
    &:disabled{
        color:${assets().color.disabled};
        background-color:${assets().color.white};
        border:1px solid #BDBDBD;
    }
`;
const SButtonBlueStyle = styled(SButtonBaseOutlineStyle)`
    color: ${assets().color.white};
    background-color: ${assets().color.blue};
    &:hover{
        background-color: ${assets().color.blueHover};
        cursor: pointer;
    }
    &:active{
        background-color:${assets().color.white};
        color:${assets().color.blue};
    };
`;
const SlabelBalloonStyle = styled.label`//ツールチップ
    text-align:center;
    height: fit-content;
    display: none;
    position: absolute;
    border-radius: 3px;
    z-index: 2;
    bottom: 15px;
    left:  15%;
    top:  -90%;
    background-color: black;
    opacity:0.7;
    color: #ffffff;
    padding: 2px 8px;
    width: ${props=>props.width};
    max-width:200px;
    transform:translate(-20px,-14px);
    overflow-wrap:break-word;
    /* white-space: ${props=>props.width ?'normal':'nowrap'}; */
    :after {
        position: absolute;
        top: 100%;
        left: 50%;
        border: 5px solid transparent;
        border-top: 10px solid black; 
      content: " ";
    }
`;

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* スタイル */
const CommonStyle =  StyleCommon();//共通スタイルドコンポーネント
/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */

export const StyleEmployee = () => {

    /* ====== 詳細ページタイトル ====== */
     const SdivTitleButton = ({children} ) => {
        return(
            <SdivTitleButtonStyle className='titleText' style={{minWidth:assets().size.leftTableCellL, fontSize:assets().size.titleText}}>{children}</SdivTitleButtonStyle>
        )
    }
    /* ====== 詳細ページ外枠 ====== */
     const SdivWrapper = ({children} ) => {
        return(

            <SdivWrapperStyle  className='baseText' style={{minWidth:assets().size.leftTableCellL}}>{children}</SdivWrapperStyle>

        )
    }
    /* ====== SVGアイコン ====== */
     const SsvgIcon = ({onClick, disabled, type, children} ) => {
        return(
            <SsvgIconStyle onClick={onClick} className='svgStyle' style={{height:assets().size.svgHeight,width:assets().size.svgWidth}}>{children}</SsvgIconStyle>
        )
    }
    /* ====== 適用日枠 ====== */
     const SdivApply = ({children} ) => {
        return(
            <SdivApplyStyle className='svgStyle' style={{height:assets().size.svgHeight,width:assets().size.svgWidth}}>{children}</SdivApplyStyle>

        )
    }
    /* ====== 枠のみボタン ====== */
     const SButtonBaseOutline = ({children,text,border,onClick} ) => {
        return(
            <>
                <SButtonBaseOutlineStyle 
                className='buttonStyle'
                style={{fontSize:assets().size.baseText,height:assets().size.buttonHeight,width : assets().size.buttonWidth}}
                border={border}
                type='button'
                onClick={onClick}
                >{children}
                <SlabelBalloonStyle className='fontsizeButtonTooltipText' style={{fontSize:assets().size.fontsizeButtonTooltipText}}>
                    {text.split('\n').map((item, index) => (  
                        <p key={`${item}${index}`}style={{margin: '0px', textAlign: 'left'}}>{item}</p>
                    ))}
                </SlabelBalloonStyle>

                </SButtonBaseOutlineStyle>
            </>
        )
    }
    /* ====== 色付きボタン ====== */
     const SButtonBlue = ({children,border,text,onClick} ) => {
        return(
            <>
            <SButtonBlueStyle 
                className='buttonStyle' 
                style={{fontSize:assets().size.baseText,height:assets().size.buttonHeight,width:assets().size.buttonWidth}}
                border={border}
                type='button'
                onClick={onClick}
                >
                    {children}
                <SlabelBalloonStyle className='fontsizeButtonTooltipText' style={{fontSize:assets().size.fontsizeButtonTooltipText}}>
                    {text.split('\n').map((item, index) => (  
                        <p key={`${item}${index}`}style={{margin: '0px', textAlign: 'left'}}>{item}</p>
                    ))}
                </SlabelBalloonStyle>

            </SButtonBlueStyle>
            </>
        )
    };

    /* ====== ブロックのテンプレート ====== */
    const SInformationBlock = ({id, blockTitle, buttonState,editButtonState,copyButtonState,deleteButtonState, onClickCopy, onClickUpdate, onClickDelete,onClickRegister,children}) =>{
        return(
            <>
            <CommonStyle.GdivSubTitleWrapper id={id}>
                <SdivTitleButton>
                    {blockTitle}
                    {/* 編集中ならキャンセルボタンを表示 */}
                    {buttonState === id  &&
                            <IconDelete onClick={()=>onClickUpdate(id)}/>}
                    {/* buttonStateがundefinedならボタンを表示*/}
                    {buttonState === undefined ?
                        <>
                        {editButtonState?.[id] && 
                        (onClickUpdate &&<IconButtonEdit onClick={()=>onClickUpdate(id)}/>)}
                        {onClickRegister &&
                        <ButtonIconRegisterAuthEdit onClick={()=>onClickRegister(id)}/>}
                        {copyButtonState?.[id]&&
                        (onClickCopy && <ButtonIconCopyRegister onClick={()=>onClickCopy(id)}/>)}
                        {deleteButtonState?.[id]&&
                        <IconButtonDelete onClick={()=>onClickDelete(id)}/>}
                        </>
                    :''}
                </SdivTitleButton>
            </CommonStyle.GdivSubTitleWrapper>
            {children}
            </> 
           
        )
    };
    /* ====== ブロックのテンプレート ====== */
    const SInformationTable = ({id, blockTitle, buttonState, onClickUpdate,children}) =>{
        return(
            <>
                <CommonStyle.GdivSubTitleWrapper id={id}>
                    <SdivTitleButton>
                        {blockTitle}
                        {onClickUpdate ?
                           <>
                                {/* 編集中ならキャンセルボタンを表示 */}
                                {buttonState === id ?
                                    <IconDelete onClick={()=>onClickUpdate(id)}/>
                                :''}
                                {/* buttonStateがundefinedならボタンを表示*/}
                                {buttonState === undefined ?
                                    <IconButtonEdit onClick={()=>onClickUpdate(id)}/>
                                :''}
                            </>
                        :
                            ''
                        }
                    </SdivTitleButton>
                </CommonStyle.GdivSubTitleWrapper>
                {children}
            </>
        )
    }


    return {
        SdivTitleButton,
        SdivWrapper,
        SsvgIcon,
        SdivApply,
        SButtonBaseOutline,
        SButtonBlue,
        SInformationBlock,
        SInformationTable
    }
}

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */